import { create } from 'zustand';
import type { MatchConfig, StoryType } from '../api/types';

export const DEFAULT_CONFIG: MatchConfig = {
  minScore: 0.3,
  minEvent: 0.25,
  minLocation: 0.20,
  minTime: 0.15,
  rerankTopM: 10,
  fusionAlpha: 0.75,
  bypassFloor: 0.25,
  proximityRadiusMeters: {
    stranger: 200,
    crush: 500,
    ex: null,
  },
  dimensionWeights: {
    stranger: { event: 0.30, location: 0.26, appearance: 0.16, time: 0.14, identity: 0.06, mirror: 0.06, uniquenessBonus: 0.02 },
    crush:    { event: 0.16, location: 0.14, appearance: 0.22, time: 0.08, identity: 0.26, mirror: 0.10, uniquenessBonus: 0.04 },
    ex:       { event: 0.12, location: 0.10, appearance: 0.14, time: 0.06, identity: 0.26, mirror: 0.12, uniquenessBonus: 0.20 },
  },
};

interface ConfigState {
  config: MatchConfig;
  isModified: boolean;

  // Actions
  setGate: (key: 'minScore' | 'minEvent' | 'minLocation' | 'minTime', value: number) => void;
  setRerankTopM: (value: number) => void;
  setFusionAlpha: (value: number) => void;
  setBypassFloor: (value: number) => void;
  setProximityRadius: (storyType: StoryType, value: number | null) => void;
  resetToDefaults: () => void;
  loadConfig: (config: MatchConfig) => void;
}

export const useConfigStore = create<ConfigState>((set) => ({
  config: { ...DEFAULT_CONFIG },
  isModified: false,

  setGate: (key, value) => {
    set((state) => ({
      config: { ...state.config, [key]: value },
      isModified: true,
    }));
  },

  setRerankTopM: (value) => {
    set((state) => ({
      config: { ...state.config, rerankTopM: value },
      isModified: true,
    }));
  },

  setFusionAlpha: (value) => {
    set((state) => ({
      config: { ...state.config, fusionAlpha: value },
      isModified: true,
    }));
  },

  setBypassFloor: (value) => {
    set((state) => ({
      config: { ...state.config, bypassFloor: value },
      isModified: true,
    }));
  },

  setProximityRadius: (storyType, value) => {
    set((state) => ({
      config: {
        ...state.config,
        proximityRadiusMeters: {
          ...state.config.proximityRadiusMeters,
          [storyType]: value,
        },
      },
      isModified: true,
    }));
  },


  resetToDefaults: () => {
    set({
      config: { ...DEFAULT_CONFIG },
      isModified: false,
    });
  },

  loadConfig: (config) => {
    set({
      config: { ...config },
      isModified: false,
    });
  },
}));
